module.exports = __webpack_public_path__ + "img/c72.a0b6ebbd.png";